import type { SvgIconPropsWithChildren } from '../common/SvgIcon';

import React, { createElement } from 'react';

import { SvgIcon } from '../common/SvgIcon';

function SvgTelegram(props: SvgIconPropsWithChildren) {
  return createElement(
    SvgIcon,
    props,
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.9-.74 1.12-1.5.7L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"
        fill="currentColor"
      />
    </svg>,
  );
}
export default SvgTelegram;
